<template>
    <div>
        <template v-if="likes.like">
            <h2 class="no-margin">{{likeText}} ({{likes.like}})</h2>
            <div class="user-container-list no-padding">
                <person-box-user v-for="id in likes.likeUserIds" :key="id" :id="id"/>
            </div>
        </template>
        <template v-if="likes.dislike">
            <h2 class="no-margin">{{dislikeText}} ({{likes.dislike}})</h2>
            <div class="user-container-list no-padding">
                <person-box-user v-for="id in likes.dislikeUserIds" :key="id" :id="id"/>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import {defineAsyncComponentWrapper} from '@/library/utils';

    const personBoxUser = defineAsyncComponentWrapper(() => import('./PersonBoxUser.vue'));

    const props = withDefaults(
        defineProps<{
            likes: object;
            likeText?: string;
            dislikeText?: string;
        }>(),
        {
            likeText: '',
            dislikeText: '',
        },
    );
</script>